import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';
interface Props {
  isBorderRadius?: boolean;
  isActive?: boolean;
  variant?: 'no-border' | 'border' | 'hover-border';
  iconTone?: 'fill' | 'stroke';
  size?: 'small' | 'medium';
  isDifferentPadding?: boolean;
  isProjectTemplate?: boolean;
}
const Title = styled.p<Props>`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const ButtonMainDiv = styled.div<Props>`
  padding: ${({ isProjectTemplate }) => (isProjectTemplate ? 'var(--space-0)' : `var(--space-5) var(--space-11)`)};
  ${AlignCenter}
  gap: var(--space-10);
  border: 0.5px solid transparent;
  border-radius: var(--border-radius-8);
  cursor: ${({ isProjectTemplate }) => (isProjectTemplate ? 'unset' : 'pointer')};
  svg {
    ${(props: Props) =>
      props.iconTone === 'fill' &&
      css`
        fill: var(--text-secondary);
      `}
    ${(props: Props) =>
      props.iconTone === 'stroke' &&
      css`
        stroke: var(--text-secondary);
        fill: none;
      `}
  }
  ${(props: Props) =>
    props.isBorderRadius &&
    css`
      border-radius: var(--border-radius-full);
      padding: var(--space-4);
    `}
  ${(props: Props) =>
    props.variant === 'no-border' &&
    css`
      border: none;
      padding: var(--space-0);
    `}
    ${(props: Props) =>
    props.variant === 'border' &&
    css`
      border: 0.5px solid var(--border-primary);
    `}

  ${(props: Props) =>
    props.isActive &&
    css`
      background: var(--neutral-secondary);
      border-radius: var(--border-radius-8);
      p {
        color: var(--text-primary);
      }
      svg {
        ${(props: Props) =>
          props.iconTone === 'fill' &&
          css`
            fill: var(--text-primary);
          `}
        ${(props: Props) =>
          props.iconTone === 'stroke' &&
          css`
            stroke: var(--text-primary);
            fill: none;
          `}
      }
      ${(props: Props) =>
        props.isBorderRadius &&
        css`
          border-radius: var(--border-radius-full);
          padding: var(--space-4);
        `}
      ${(props: Props) =>
        props.variant === 'hover-border' &&
        css`
          border: 0.5px solid var(--border-primary);
          background-color: var(--background-primary);
        `}
      ${(props: Props) =>
        props.variant === 'no-border' &&
        css`
          background: unset;
        `}
    `}

  &:hover {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
    p {
      color: var(--text-primary);
    }
    svg {
      ${(props: Props) =>
        props.iconTone === 'fill' &&
        css`
          fill: var(--text-primary);
        `}
      ${(props: Props) =>
        props.iconTone === 'stroke' &&
        css`
          stroke: var(--text-primary);
          fill: none;
        `}
    }
    ${(props: Props) =>
      props.isBorderRadius &&
      css`
        border-radius: var(--border-radius-full);
        padding: var(--space-4);
      `}
    ${(props: Props) =>
      props.variant === 'hover-border' &&
      css`
        border: 0.5px solid var(--border-primary);
        background-color: var(--background-primary);
      `}
      ${(props: Props) =>
      props.variant === 'no-border' &&
      css`
        background: unset;
      `}
  }
  ${(props: Props) =>
    props.size === 'small' &&
    css`
      padding: var(--space-2) var(--space-7);
      gap: var(--space-6);
      border-radius: var(--border-radius-6);
      &:hover {
        border-radius: var(--border-radius-6);
      }
    `}

  ${(props: Props) =>
    props.isDifferentPadding &&
    css`
      padding: var(--space-4) var(--space-7);
    `}
`;
const Icon = styled.div`
  ${FlexCenter}
`;

export { ButtonMainDiv, Title, Icon };
